/**
 * BFF handoff bootstrap — Auth-2.0 Fase 2 (NAGI 2026-04-30).
 *
 * Ver detalle en /var/www/pre.totalcheck.es/frontend/src/bootstrap/bff-handoff.ts
 * (mismo patron en los 5 portales). Canjea `?bff_handoff=<code>` por la
 * cookie HttpOnly `bff_session` antes de montar React.
 */

const BFF_BASE_URL =
  (import.meta.env.VITE_BFF_BASE_URL as string)

export async function consumeBffHandoff(): Promise<void> {
  if (typeof window === 'undefined') return
  const params = new URLSearchParams(window.location.search)
  const code = params.get('bff_handoff')
  if (!code) return

  params.delete('bff_handoff')
  const newQs = params.toString()
  const newUrl =
    window.location.pathname + (newQs ? `?${newQs}` : '') + window.location.hash
  window.history.replaceState({}, '', newUrl)

  try {
    await fetch(`${BFF_BASE_URL.replace(/\/$/, '')}/api/v1/auth/handoff`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code }),
    })
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[bff-handoff] redemption failed:', err)
  }
}
